export default __webpack_public_path__ + "static/media/info.8a5a2cca.svg";